import React from 'react';
import {ActivityIndicator, View} from 'react-native';
import {
  Button,
  Divider,
  Dialog as PaperDialog,
  Portal,
} from 'react-native-paper';
import _ from 'lodash';

import sy from '~/styles';

import {Text} from '~/components/controls';

const Dialog = ({
  style,
  visible,
  dismissable,
  onDismiss,
  title,
  titleIcon,
  children,
  buttons,
  options = {
    hideDividers: false,
    showFooterLoading: false,
    noPaddingContent: false,
  },
}) => {
  let footer = <Button onPress={onDismiss}>OK</Button>;
  if (buttons) {
    footer = buttons.map((button, index) => (
      <Button key={index} onPress={button.onPress}>
        {button.text}
      </Button>
    ));
  }

  return (
    <Portal>
      <PaperDialog
        style={style}
        visible={visible}
        dismissable={onDismiss ? dismissable : false}
        onDismiss={onDismiss}>
        {title && (
          <>
            <View
              style={[
                sy['flex-row'],
                sy['justify-between'],
                sy['items-center'],
                {marginLeft: 24, marginRight: 24, minHeight: 64},
              ]}>
              {_.isString(title) ? (
                <Text style={[sy.largePlus]}>{title}</Text>
              ) : (
                title
              )}
              {titleIcon}
            </View>
            {!options.hideDividers && <Divider style={sy['bg-gray88']} />}
          </>
        )}
        <PaperDialog.Content
          style={[
            {paddingBottom: 0},
            options.noPaddingContent ? {paddingHorizontal: 0} : null,
          ]}>
          {children}
        </PaperDialog.Content>
        {!options.hideDividers && <Divider style={sy['bg-gray88']} />}
        <PaperDialog.Actions>
          {options.showFooterLoading ? (
            <ActivityIndicator size="large" color="#231fda" />
          ) : (
            footer
          )}
        </PaperDialog.Actions>
      </PaperDialog>
    </Portal>
  );
};

export default Dialog;
